import { useMemo } from 'react'

import { RoleReassignmentOption } from 'clickNgo/features/contact/contactReassignment'
import { contactRelinkingModalTranslations } from 'clickNgo/features/contact/contactRelinking/contactRelinkingValidationModal/translation'
import { Nullable } from 'clickNgo/models/utils'
import { InfoBlock, InfoBlockRounded, InfoBlockType } from 'cng-common/components/infoBlock'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Radio } from 'core-components/library/radio'

interface IReassignUniqueRolesDetailsProps {
  rolesForRemovingFromRelinkingContacts: string[]
  targetPartnerContactsRoles: string[]
  isAskingHowRemoveUniqueRoles: boolean
  reassignmentUniqueRolesOption: Nullable<RoleReassignmentOption>
  setReassignmentUniqueRolesOption: (value: RoleReassignmentOption) => void
  commonUniqueRolesWithTarget: string[]
}

export const ReassignUniqueRolesDetails = ({
  rolesForRemovingFromRelinkingContacts,
  isAskingHowRemoveUniqueRoles,
  targetPartnerContactsRoles,
  reassignmentUniqueRolesOption,
  setReassignmentUniqueRolesOption,
  commonUniqueRolesWithTarget,
}: IReassignUniqueRolesDetailsProps) => {
  const branchOnlineTranslation = useMemo(() => {
    if (rolesForRemovingFromRelinkingContacts.length && targetPartnerContactsRoles.length) {
      return contactRelinkingModalTranslations.reassignUniqueRoles.reassigningForBranchAndOnline
        .forRelinkingAndTarget
    }
    if (rolesForRemovingFromRelinkingContacts.length && !targetPartnerContactsRoles.length) {
      return contactRelinkingModalTranslations.reassignUniqueRoles.reassigningForBranchAndOnline
        .forRelinking
    }
    return contactRelinkingModalTranslations.reassignUniqueRoles.reassigningForBranchAndOnline
      .forTarget
  }, [targetPartnerContactsRoles, rolesForRemovingFromRelinkingContacts])

  if (!rolesForRemovingFromRelinkingContacts.length && !targetPartnerContactsRoles.length) {
    return <div />
  }

  return (
    <div>
      <hr />
      <RenderWhen condition={isAskingHowRemoveUniqueRoles}>
        <div>
          <Translation
            text={contactRelinkingModalTranslations.reassignUniqueRoles.reassignmentOptions.title}
            replaceParams={[
              {
                key: '{roles}',
                value: commonUniqueRolesWithTarget.join(', '),
              },
            ]}
          />

          <Radio
            checked={
              reassignmentUniqueRolesOption === RoleReassignmentOption.RemoveFromMovingContact
            }
            value={RoleReassignmentOption.RemoveFromMovingContact}
            onChange={setReassignmentUniqueRolesOption}
            padding
            inline
            label={
              <Translation
                text={
                  contactRelinkingModalTranslations.reassignUniqueRoles.reassignmentOptions.remove
                }
              />
            }
          />
          <Radio
            checked={
              reassignmentUniqueRolesOption ===
              RoleReassignmentOption.RemoveFromTargetPartnerContacts
            }
            value={RoleReassignmentOption.RemoveFromTargetPartnerContacts}
            onChange={setReassignmentUniqueRolesOption}
            padding
            inline
            label={
              <Translation
                text={
                  contactRelinkingModalTranslations.reassignUniqueRoles.reassignmentOptions.keep
                }
              />
            }
          />
        </div>
      </RenderWhen>

      <RenderWhen condition={!isAskingHowRemoveUniqueRoles}>
        <InfoBlock
          text={
            <Translation
              text={branchOnlineTranslation}
              replaceParams={[
                {
                  key: '{fromRelinking}',
                  value: rolesForRemovingFromRelinkingContacts.join(', '),
                },
                {
                  key: '{fromTarget}',
                  value: targetPartnerContactsRoles.join(', '),
                },
              ]}
            />
          }
          type={InfoBlockType.Warning}
          rounded={InfoBlockRounded.Medium}
        />
      </RenderWhen>
    </div>
  )
}
